import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, Validators, FormGroup, FormArray, FormControl } from '@angular/forms';
import { MemberofficeService } from '@app/services/memberoffices/memberoffice.service';
import { MemberShort } from '@app/models/member';
import { Subscription, Observable } from 'rxjs';
import { Sign } from '@app/models/sign';
import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe';
import { SelectedSign } from '@app/models/selectedsign';
import { MemberService } from '@app/services/member.service';
import { Enumroles } from '@app/models/enumroles.enum';
import { ClaimsService } from '@app/services/claims/claims.service';
import { InstitutionsService } from '@app/services/institutions/institutions.service';
import { startWith, map } from 'rxjs/operators';
import { Sort } from '@angular/material/sort';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { SnackbarService } from '@app/services/shared/snackbar.service';
import { SortService } from '@app/components/sorting/SortService';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { MembershipService } from '@app/services/membership.service';
import { PermissionsService } from '@app/services/permissions/permissions.service';
import { SelectItem } from 'primeng/api';

interface LodgeAndCamp {
  id: number;
  shortName: string;
  name: string;
}

@Component({
  selector: 'app-grader',
  templateUrl: './grader.component.html',
  styleUrls: ['./grader.component.css']
})
export class GraderComponent implements OnInit, OnDestroy {

  minmaxyear = { minYear: '1920', maxYear: '9999' };
  autoCorrectedDatePipe = createAutoCorrectedDatePipe('yyyy-mm-dd', this.minmaxyear);
  public mask = [/[1-9]/, /\d/, /\d/, ' ', /\d/, /\d/]; // zipcode
  public maskdatum = [/[129]/, /[?09]/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/];
  valid = false;
  type;
  memberids: number[] = [];
  members: MemberShort[] = [];
  selectedmembers: MemberShort[] = [];
  signs: Sign[] = [];
  selected: MemberShort[] = [];
  selectedmember: MemberShort;

  showFilteredList = false;
  disablemycontrol = false;
  baseinfo;
  selectedSigns: SelectedSign[] = [];
 form;
 

  institutionlist: LodgeAndCamp[] = [];
  institutionslist: SelectItem[] = [];
  selectedSignsForm: FormGroup;
  items: FormArray;
  subscriptions: Subscription[] = [];
  searchTerm: string;
  isClerk = false;
  isSysAdmin = false;
  countrylist: any[];
  selected1;
  added = 0;
  activememberships;
  responseinfo: string[] = [];
  myControl = new FormControl();
  data: LodgeAndCamp[] = [];
  institutions: LodgeAndCamp[] = [];
  filteredOptions: Observable<LodgeAndCamp[]>;
  selectedinstitution: any;
  selectedinstitutionname: string;
  currentinstitution;
  memberships;
  useraccess;
  // tslint:disable-next-line:max-line-length
  constructor(
    private permissionsService: PermissionsService,
    private router: Router,
    private membershipService: MembershipService,
    private route: ActivatedRoute,
    private snackbarService: SnackbarService,
    private claimsService: ClaimsService,
    private institutionsService: InstitutionsService,
    private fb: FormBuilder,
    private memberofficeService: MemberofficeService,
    private memberService: MemberService) { 
     
    }

  addSigns() {
    this.memberids = [];
    this.responseinfo = [];
    let antal = 0;
    this.added = 0;

    if (this.form.get('institutionId').value) {
      this.selectedSignsForm.controls.items.value.forEach(element => {
        element.institutionId = this.form.get('institutionId').value;
      });
    }
    antal = this.selectedSignsForm.controls.items.value.length;

    if (this.useraccess.roleId === 12 || this.useraccess.roleId === 13) {
      if (this.form.get('officeInstitutionId').value) {
        this.selectedSignsForm.controls.items.value.forEach(element => {
          element.institutionId = this.form.get('officeInstitutionId').value;
        });
      }
    }

    this.subscriptions.push(this.memberofficeService.UpdateMemberSign(this.selectedSignsForm.controls.items.value).subscribe(resp => {
      let idx = 0;
      resp.forEach(item => {
        let memberid;
        this.responseinfo.push(item.status);
        if (this.selectedSignsForm.controls.items.value[idx]) {
          memberid = this.selectedSignsForm.controls.items.value[idx].memberId;
        }
        if (item.rowsAffected !== 0) {
          this.added++;
          // If adding sign to member then remove added member from list.
          this.memberids.push(memberid);
          this.memberService.timestamp.next(+new Date());
        }
        idx++;
      });
      this.snackbarService.openSnackBar(this.added + ' av ' + antal + ' utmärkelser tillagda', null);
      this.memberids.forEach(memberid => {
        this.uncheckMember(memberid);
      });
      this.memberids.forEach(memberid => {
        this.removeAddedRow(memberid);
      });
      this.memberids.forEach(memberid => {
        this.removeSelectedMember(memberid);
      });
    }));
  }

  addOffice() {
    this.selectedmember = null;
  }

  clear() {
    this.myControl.setValue(null);
  }

  institutionSelected(evt) {
    this.selectedinstitution = evt.value.id;
    this.form.get('officeInstitutionId').setValue(evt.value.id);
    if (this.useraccess.roleId === 12 || this.useraccess.roleId === 13) {
      this.getSignsByInstitutionId(evt.value.id);
      
    }
    this.selectedinstitutionname = evt.value.name;
  }

  ngOnInit() {
    this.form = this.fb.group({
      memberId: ['', ''],
      givenName: ['', ''],
      familyName: ['', ''],
      institutionId: [null, null],
      officeInstitutionId: ['', ''],
      IncludeNonCurrentInstitutions: [false, '']
    });
    
    this.permissionsService.selectedrole.subscribe(resp => {
      this.useraccess = resp;
    });

    this.router.events.subscribe(x => {
      if (x instanceof NavigationEnd) {
        this.clearSelectedSignsForm();
      }
    });

    this.route.queryParams.subscribe(qParam => {
      if (qParam.type === 'member') {
        this.type = 'member';
        this.form.patchValue({ memberId: qParam.memberid, givenName: null, familyName: null });
        this.searchForSpecificMember(qParam.memberid);
        this.checkMember(qParam.memberid);
        this.membershipService.getMembershipByMemberId(qParam.memberid).subscribe(memberships => {
          if (memberships) {
            this.memberships = memberships;
            // Lista endast aktiva medlemskap om det inte är en kanslist som kör.
            if (this.useraccess.roleId !== 13) {
              this.memberships = this.memberships.filter(m => m.endDate.startsWith('9999'));
            }
            if (this.useraccess?.userPermissionLevel === 'IN') {
              this.memberships = this.memberships.filter(m => m.endDate.startsWith('9999') && m.institutionId === this.useraccess?.institution.id);
            }
          }
        }
        );
      } else if (qParam.type === 'institution') {
        this.type = 'institution';
        this.institutionsService.getInstitutionByIdAsync(qParam.id).subscribe(x => {
          this.currentinstitution = x;
          if (this.useraccess?.roleId === 12 || this.useraccess?.roleId === 13) {
            this.selectedinstitutionname = this.currentinstitution.shortName + ' - ' + this.currentinstitution.name;
            this.selectedinstitution = this.currentinstitution;
          }
          this.form.patchValue({ institutionId: x.id });
          this.getPossibleSigns(this.currentinstitution.id);
        });

      }
    });

    this.selectedSignsForm = this.fb.group({
      items: this.fb.array([])
    });

    this.getAllInstitutions();

    this.subscriptions.push(this.claimsService.claims$.subscribe(data => {
      this.baseinfo = data;
      if (data) {
        this.listClaims();
      }
    }));

    if (this.claimsService.isClerk() || this.claimsService.isSysAdmin()) {
      this.isClerk = this.claimsService.isClerk();
      this.isSysAdmin = this.claimsService.isSysAdmin();
      this.subscriptions.push(this.institutionsService.getInstitutions().subscribe(data => {
        if (data) {
          data.forEach(element => {
            const inst = { id: element.id, shortName: element.shortName, name: element.name };
            this.data.push(inst);
          });
        }
        this.filteredOptions = this.myControl.valueChanges
          .pipe(
            startWith<string | LodgeAndCamp>(''),
            map(value => typeof value === 'string' ? value : value.name),
            map(name => name ? this._filter(name) : this.data.slice())
          );
      }));
    }
    this.populateOffices();
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => {
      sub.unsubscribe();
    });
  }

  getPossibleSigns(institutionId: number) {
    
    if (institutionId === 0) {
      this.signs = [];
    } else {
      this.subscriptions.push(this.memberofficeService.GetPossibleSigns(institutionId).subscribe(data => {
        this.signs = data;
      }));
    }
  }

  listClaims() {
    this.institutionlist = [];
    this.baseinfo.claimsList.forEach(element => {
      if (element.key === Enumroles.ADMIN_LODGE || element.key === Enumroles.ADMIN_CAMP) {
        const lodgeOrcamp: LodgeAndCamp = {
          id: element.value.id,
          shortName: element.value.shortName,
          name: element.value.name
        };
        this.institutionlist.push(lodgeOrcamp);
      }
    });
  }

  createItem(member: MemberShort, element: any): FormGroup {
    return this.fb.group({
      memberId: member.id,
      institutionId: this.form.get('institutionId').value,
      givenName: member.givenName,
      familyName: member.familyName,
      signId: ['', Validators.required],
      action: ['add', ''],
      date: ['', Validators.required]
    });
  }
  getSigns2() {
    if (this.useraccess.roleId === 12 || this.useraccess.roleId === 13) {
      this.form.patchValue({ institutionId: Number(this.form.get('institutionId').value) });
    }
    this.getPossibleSigns(Number(this.form.get('institutionId').value));
  }

  getAllInstitutions() {
    this.institutionsService.getInstitutions().subscribe(response => {
      this.institutions = response.sort((a, b) => {
        return SortService.cmpStringsWithNumbers(a.shortName, b.shortName, false);
      });
      this.institutions.forEach(x => {
        x.name = x.shortName + ' ' + x.name;
      });
      this.institutions = this.institutions.filter(x => ((x.name)).toLowerCase().indexOf('distrikt') === -1);
      this.institutionslist = [];
      if (this.institutions) {
        this.institutions.forEach(d => {
          const record = {
            label: d.name, value: d.id
          };
          this.institutionslist.push(record);
        });
        const emptyrecord = {
          label: '', value: null
        };
        this.institutionslist.unshift(emptyrecord);
      }
    });
  }

  setOnlyActive(element) {
    this.form.patchValue({ IncludeNonCurrentInstitutions: element.checked });
  }

  addItem(member: MemberShort, element: any): void {
    this.items = this.selectedSignsForm.get('items') as FormArray;
    this.items.push(this.createItem(member, element));
  }

  search() {
    this.responseinfo = [];
    this.subscriptions.push(this.memberService.SearchMemberForOfficesAndSigns(this.form.value).subscribe(data => {
      this.members = data;
    }));
  }

  searchForSpecificMember(memberid) {
    this.subscriptions.push(this.memberService.SearchMemberForOfficesAndSigns(this.form.value).subscribe(data => {
      if (data) {
        this.members = data;
        this.selectedmembers.push(this.members[0]);
        this.form.patchValue({ givenName: data[0]?.givenName, familyName: data[0]?.familyName });
        this.checkMember(memberid);
      }
    }));
  }

  validate(evt: any) {
    if (evt.target.value !== null) {
      this.valid = true;
    } else {
      this.valid = false;
    }
  }

  checkMember(memberid: number) {
    return this.selectedmembers.find(item => item?.id === memberid);
  }

  uncheckMember(memberid: number) {
    const idx = this.members.findIndex(item => item.id === memberid);
    if (this.members[idx]) {
      this.members[idx].checked = false;
    }
  }

  add(selectedmember, element) {
    if (element?.checked) {
      this.addItem(selectedmember, element);
      this.selectedmembers.push(selectedmember);
      this.filterList(selectedmember.id);
      this.members[this.members.findIndex(item => item.id === selectedmember.id)].checked = true;
    } else {
      this.removeFromArray(selectedmember.id);
      this.filterListById(selectedmember.id);
      this.removeSelectedMember(selectedmember.id);
    }
    this.selectedmember = selectedmember;
  }

  removeSelectedMember(id: number) {
    const elementidx = this.selectedmembers.findIndex(obj => obj?.id === id);
    this.selectedmembers.splice(elementidx, 1);
  }

  filterList(id: number) {
    const sign = { memberId: id, id: null, date: null };
    this.selectedSigns.push(sign);
    this.showFilteredList = true;
  }

  filterListById(id: number) {
    const signidx = this.selectedSigns.findIndex(obj => obj.memberId === id);
    this.selectedSigns.splice(signidx, 1);
  }

  removeAddedRow(id: number) {
    this.items.removeAt(this.items.value.findIndex(item => item.memberId === id));
  }

  removeFromArray(id: number) {
    const idx = this.members.findIndex(item => item.id === id);
    this.responseinfo.splice(idx, 1);
    this.members[idx].checked = false;
    this.items.removeAt(this.items.value.findIndex(item => item.memberId === id));
    this.removeSelectedMember(id);
  }

  getSigns(event: any) {
    this.signs = [];
    this.getPossibleSigns(Number(event.target.value));
    if (this.members.length > 0) {
      this.members = [];
    }
  }

  getSignsByInstitutionId(institutionid: number) {
    this.signs = [];
    this.getPossibleSigns(institutionid);
  }

  filterData() {
    this.data
      .filter(item => item.name === this.searchTerm);
  }

  getUserIdsFirstWay(evt: any) {
    console.log(this.searchTerm);
  }

  private _filter(name: string): LodgeAndCamp[] {
    const filterValue = name.toLowerCase();
    // tslint:disable-next-line:max-line-length
    return this.data.filter(option => option.name.toLowerCase().indexOf(filterValue) !== -1 || option.shortName.toLowerCase().indexOf(filterValue) !== -1);
  }

  displayFn(user?: LodgeAndCamp): string | undefined {
    return user ? user.shortName + ' ' + user.name : undefined;
  }

  onSelectionChanged(event: MatAutocompleteSelectedEvent) {
    this.clearSelectedSignsForm();
    this.selectedinstitution = event.option.value.id;
    this.form.get('institutionId').setValue(event.option.value.id);
    this.getSignsByInstitutionId(event.option.value.id);
    this.selectedinstitutionname = event.option.value.shortName + ' ' + event.option.value.name;
  }

  clearSelectedSignsForm() {
    for (const c of this.selectedSignsForm.controls.items.value) {
      this.removeFromArray(c.memberId);
    }
  }

  sortData(sort: Sort) {
    const data = this.members.slice();
    if (!sort.active || sort.direction === '') {
      this.members = data;
      return;
    }
    this.members = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'id': return this.compare(a.id, b.id, isAsc);
        case 'givenName': return this.compare(a.givenName, b.givenName, isAsc);
        case 'familyName': return this.compare(a.familyName, b.familyName, isAsc);
        default: return 0;
      }
    });
  }

  compare(a: number | string | Date, b: number | string | Date, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  populateOffices() {
    const institutionid = this.currentinstitution?.id;
    this.clearSelectedSignsForm();
    this.selectedinstitution = institutionid;
    this.form.get('institutionId').setValue(institutionid);
    this.selectedinstitutionname = this.currentinstitution?.name;
  }

  get memberId() {
    return this.form.get('memberId').value;
  }

  get givenName() {
    return this.form.get('givenName').value;
  }

  get familyName() {
    return this.form.get('familyName').value;
  }

}
